module.exports = __webpack_public_path__ + "1eecf71d700cb3f18b8188c00de9c181.svg";